import type { BrandTerm } from '@tsTypes/api/BrandTerm';

const getConsentCheckboxLabel = ({
  additionalInfo,
  consent,
  additionalContent,
}: BrandTerm) =>
  `${consent}${
    additionalInfo && additionalContent ? ` ${additionalContent}` : ''
  }`;

export default getConsentCheckboxLabel;
